export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/695ef1c515839daea18575a784dbd6a0/080c713db4584e7c091d9e68535aaf52.jpeg" 
              alt="Consultadoria de Serviços de Saúde" 
              className="h-12 w-auto object-contain mb-6 bg-white p-2 rounded-lg"
            />
            <p className="text-sm text-white/90 leading-relaxed mb-6 max-w-md">
              Parceiros estratégicos e humanos das organizações e profissionais de saúde, contribuindo para melhores cuidados de saúde acessíveis à população.
            </p>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('sobre')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicos')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('beneficios')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Benefícios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contato')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Contato
                </button>
              </li>
              <li>
                <a 
                  href="/politica-cookies"
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Política de Cookies
                </a>
              </li>
              <li>
                <a 
                  href="/politica-privacidade"
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a 
                  href="/termos-condicoes"
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Termos e Condições
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-base mt-0.5"></i>
                <a href="mailto:consultadoriaeservicosemsaude@gmail.com" className="text-sm text-white/80 hover:text-white transition-colors break-all">
                  consultadoriaeservicosemsaude@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-base mt-0.5"></i>
                <a href="tel:919214659" className="text-sm text-white/80 hover:text-white transition-colors">
                  919 214 659
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-base mt-0.5"></i>
                <span className="text-sm text-white/80">
                  Seg-Sex: 9h - 18h
                </span>
              </li>
            </ul>
            
            <div className="flex gap-3 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61567786940277"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/110356162"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="flex flex-wrap items-center justify-center gap-4">
              <p className="text-sm text-white/80">
                © {currentYear} Consultadoria de Serviços de Saúde. Todos os direitos reservados.
              </p>
              <span className="hidden md:inline text-white/40">|</span>
              <a 
                href="https://www.livroreclamacoes.pt/Inicio/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-white hover:text-white/80 transition-colors cursor-pointer bg-white/10 px-4 py-2 rounded-lg hover:bg-white/20"
                aria-label="Livro de Reclamações Online"
              >
                <i className="ri-book-2-line text-lg"></i>
                <span className="font-medium">Livro de Reclamações</span>
              </a>
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}